import React, {useState, useEffect} from 'react';
import logo from '../../assets/logo.png';
import {Wrapper, Logo, CopyRight, VersionText, Item} from './Footer.style';

function Footer() {
  const [version, setVersion] = useState('...');

  useEffect(() => {
    fetch('/api/version')
      .then(res => res.json())
      .then(data => setVersion(data.version))
      .catch(() => setVersion('unknown'));
  }, []);

  return (
    <Wrapper>
      <Logo src={logo} />
      <Item href={'https://www.jjfoodservice.com/'}>www.jjfoodservice.com</Item>
      <CopyRight>&#169; JJ Foodservice. All Right Reserved.</CopyRight>
      <VersionText>Version - {version}</VersionText>
    </Wrapper>
  );
}

export default Footer;
